import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  previewWrapper: {
    position: 'relative',
  },
  overlayContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
  },
  topOverlay: {
    top: 0,
  },
  bottomOverlay: {
    bottom: 0,
  },
});
